import React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Stack,
} from "@mui/material";
import moment from "moment";
import CirlceCheckbox from "../../../Component/Common/ReuseableComponent/CirlceCheckbox";

const OrderCard = ({ order, handleOpen }) => {
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "0.5px solid lightgray",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        width: "100%", // Reduced width
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <CardActionArea onClick={() => handleOpen(order)}>
        <CardContent sx={{ p: 1.5 }}>
          {" "}
          {/* Reduced padding */}
          <Typography
            variant="subtitle2"
            color="primary"
            fontWeight="bold"
            sx={{ fontSize: "0.75rem" }} // Reduced font size
          >
            Order ID: {order.ID}
          </Typography>
          <Typography variant="caption" sx={{ fontSize: "0.75rem", mt: 0.5 }}>
            <strong>Date:</strong>{" "}
            {moment(order.OrderTime).format("DD-MM-YYYY")}
          </Typography>
          <Typography
            variant="caption"
            sx={{ fontSize: "0.75rem", display: "block", mt: 0.5 }}
          >
            <strong>User:</strong> {order.OrderUserName}
          </Typography>
          <Typography
            variant="caption"
            sx={{ fontSize: "0.75rem", display: "block", mt: 0.5 }}
          >
            <strong>Car Model:</strong> {order.CarModel}
          </Typography>
          <Typography
            variant="caption"
            sx={{ fontSize: "0.75rem", display: "block", mt: 0.5 }}
          >
            <strong>Location:</strong> {order.LocName}
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mt={1.5} // Reduced spacing
          >
            <Typography
              variant="caption"
              sx={{ fontSize: "0.75rem", fontWeight: "bold" }}
            >
              Status: {order.DeliveryStatus.toUpperCase()}
            </Typography>
            <CirlceCheckbox status={order.DeliveryStatus.toUpperCase()} />
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default OrderCard;
